<template>
    <div class="groups-and-users-admin-view">
        <AdminTable class="ma-4"
                    :items="items"
                    :get-headers="getHeaders" />
    </div>
</template>

<script>
    import AdminTable from "@/components/admin/AdminTable.vue";

    export default {
        components: {
            AdminTable
        },

        data() {
            return {
            };
        },

        created() {
            this.$store.dispatch("admin/loadGroupsAndUsers");
        },

        computed: {
            items() {
                return this.$store.state.admin.groupsAndUsers
                    .map(e => ({
                        id: e.id,

                        groupId: e.groupId,
                        groupGuid: e.groupGuid,
                        groupName: e.groupName,

                        userId: e.userId,
                        userName: e.userName,

                        rawItem: e
                    }));
            }
        },

        watch: {

        },

        methods: {
            getBoolString(bool) {
                return bool === true
                    ? "Да"
                    : "Нет";
            },

            getHeaders() {
                return [
                    {
                        title: "Id",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "id"
                    },
                    {
                        title: "Id группы",
                        align: "end",
                        sortable: true,
                        removable: true,
                        key: "groupId"
                    },
                    {
                        title: "Guid группы",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "groupGuid"
                    },
                    {
                        title: "Название группы",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "groupName"
                    },
                    {
                        title: "Id пользователя",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "userId"
                    },
                    {
                        title: "Имя пользователя",
                        align: "start",
                        sortable: true,
                        removable: true,
                        key: "userName"
                    }
                ];
            }
        }
    };
</script>

<style lang="scss">
    .groups-and-users-admin-view {
    }
</style>